import React from 'react'

const Footer = () => {
  return (
    <div className='max-w-[1200px] sm:h-[150px] p-12 flex justify-between mx-auto'>
        <span className='primary-color'>Anish Madgula</span>
        <p className='text-gray-600'>animadgula@gmail.com <br/> Personal Portfolio</p>
    </div>
  )
}

export default Footer